import config from "../../../../config";
import * as modules from "./modules/";

const { vendor } = config;

const NewModal = modules[vendor] ? modules[vendor] : modules["default"];

export default NewModal;
